import React from 'react';
import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import { constants } from '../../constants';



/*

Props:

• fontSize
• letterSpacing
• marginLeft
• marginRight
• color

*/

const SCLink = styled(Link)`
    display: flex;
    align-items: center;
    letter-spacing: ${props => (props.letterSpacing || props.light) ? (props.letterSpacing ? props.letterSpacing+'em' : '0.05em') : '0em'};
    font-family: ${constants.text.baseFontStyles.fontFamily};
    font-size: ${props => (props.fontSize) ? props.fontSize+'px' : '17px'};
    color: ${props => (props.color || props.light) ? (props.color ? props.color : constants.color.light ) : constants.color.dark};
    text-decoration: none;
    /* margin-left: 15px; */
    padding: 5px 0;

    :hover {
        color: ${props => (props.hoverColor || props.light) ? (props.hoverColor ? props.hoverColor : constants.color.secondary ) : constants.color.primary};
        transition: 0.5s;
        text-decoration: underline;
    }
`;

const StyledRouteLink = ({ to, onClick, children, style, ...rest }) => (
  <SCLink  style = {style} to={ to } onClick = {onClick} {...rest}>
      { children }
  </SCLink>
);

export default StyledRouteLink;

// linkStyle: {
//     marginLeft: 30,
//     color: 'rgba(255,255,255,0.8)',
//     fontSize: 14,
//     letterSpacing: '0.08em',
//     textDecoration: 'none',
// },


// WEBPACK FOOTER //
// ./src/js/components/Assests/StyledRouteLink.jsx